import React, { Component } from 'react';
import Moment from 'moment';

class PesquisaRapida extends Component {

	constructor(props) {
		super(props);
	}

	pesquisaRapida = (event) => {
		var texto = event.target.value;

		if (texto.length > 0) {
			var lista = this.props.lista.filter(item => {
				return (item.tipoValidacao.toUpperCase().includes(texto.toUpperCase()) ||
					item.moduloEfd.toUpperCase().includes(texto.toUpperCase()) ||
					item.Contribuinte.toUpperCase().includes(texto.toUpperCase()) ||
					(Moment(item.DatIni, "D/M/YYYY").format("MMM - Y").toUpperCase().includes(texto.toUpperCase())) ||
					(Moment(item.DatIni, "D/M/YYYY").format("MMM - Y").toUpperCase().includes(texto.toUpperCase())) ||
					(Moment(item.dataFormat).format("D/MM/Y [às] HH[h]mm").toUpperCase().includes(texto.toUpperCase())) ||
					(String(item.totalDivergencias).includes(texto.toUpperCase()))
				);
			});

			this.props.onUpdate(lista);
		} else {
			this.props.onUpdate(this.props.lista);
		}
	}

	render() {
		return (
			<div className="ecoforms input-group">
				<div className="input-group-prepend">
					<i className="ecoico ecoico-lupa" />
				</div>
				<input type="text" className="form-control boxBusca" onChange={this.pesquisaRapida} />
			</div>
		);
	}
}

export default PesquisaRapida;



// WEBPACK FOOTER //
// ./src/Componente/PesquisaRapida/PesquisaRapida.jsx